// extracted by mini-css-extract-plugin
module.exports = {"items":"how-it-works_items__L2nHI","item-image-wrapper":"how-it-works_item-image-wrapper__WL2_i"};